// src/pages/productTypes/ProductTypes.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import ProductTypesTable from "../../components/productTypes/ProductTypesTable";

const ProductTypes = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ProductTypesTable />
        </WrapperSection>
    );
};

export default ProductTypes;